const defaultAuthState = {
  authResponse: {},
  isAuthenticating: false,
};

export default defaultAuthState;
